<template lang="pug">
  div
    table.table.table--bars
      thead
        tr.table__row.table__row--head
          th.table__cell {{ 'base.name' | translate }}
          td.table__cell
          th.table__cell 
            .header-toggle-labels(v-if="lang === 'uk'")
              span {{ 'base.weight_cm' | translate }}
              span {{ 'base.dry_metter_cp' | translate }}
            .header-toggle-labels(v-else)
              span {{ 'base.dry_metter_cp' | translate }}
              span {{ 'base.weight_cm' | translate }}
          th.table__cell {{ 'base.humidity' | translate }}
          th.table__cell {{ 'base.price' | translate }}
          th.table__cell
      v-table-body(
        :cols="7"
        :loading="loading"
        :empty="!items.length"
        :no-permissions="!allowView")
        template(v-slot="{ isToggled, toggleRow }")
          template(v-for="ration in items")

            //- TABLE ROW
            tr.table__row(:class="{ 'table__row--merge-bottom': isToggled(ration) }")
              td.table__cell(
                :class="'cursor-pointer'"
                @click="toggleRow(ration)")
                | {{ ration.name }}
              td.table__cell
              td.table__cell(v-if="lang === 'uk'")
                .ration-toggle-container
                  span.ration-toggle-item(
                    :class="[!ration.is_dry ? 'selected' : '', isToggled(ration) ? 'cursor-pointer' : '']"
                    @click="isToggled(ration) ? setIsDry(ration, false) : null")
                    span.ration-selected-item {{ formatNumber(totalWeight(ration)) }} {{ 'base.kg' | translate }}
                  span.ration-toggle-item(
                    :class="[ration.is_dry ? 'selected' : '', isToggled(ration) ? 'cursor-pointer' : '']"
                    @click="isToggled(ration) ? setIsDry(ration, true) : null")
                    span.ration-selected-item {{ formatNumber(totalDryWeight(ration)) }} {{ 'base.kg' | translate }}

              td.table__cell(v-if="lang !== 'uk'")
                .ration-toggle-container
                  span.ration-toggle-item(
                    :class="[ration.is_dry ? 'selected' : '', isToggled(ration) ? 'cursor-pointer' : '']"
                    @click="isToggled(ration) ? setIsDry(ration, true) : null")
                    span.ration-selected-item {{ formatNumber(totalDryWeight(ration)) }} {{ 'base.kg' | translate }}
                  span.ration-toggle-item(
                    :class="[!ration.is_dry ? 'selected' : '', isToggled(ration) ? 'cursor-pointer' : '']"
                    @click="isToggled(ration) ? setIsDry(ration, false) : null")
                    span.ration-selected-item {{ formatNumber(totalWeight(ration)) }} {{ 'base.kg' | translate }}
              td.table__cell.nowrap.min-width-cell {{ formatNumber(rationHumidity(ration)) }} %
              td.table__cell.nowrap.min-width-cell {{ formatNumber(totalPrice(ration)) }} {{ 'base.currency' | translate }}
              td.table__cell.table__cell--action
                .flex.align-center
                  v-btn(
                    icon
                    :disabled="isConsultant"
                    @click="$emit('edit', ration)")
                    v-icon(
                      font-size="1"
                      icon="cog")
                  v-btn(
                    icon
                    @click="toggleRow(ration)")
                    v-chevron(:value="isToggled(ration)")

            //- ROW EXTENDED
            tr.table__row.table__row--merge-top(
              v-if="isToggled(ration)")
              td.table__cell.p-0(
                colspan="7")
                table.table
                  thead
                    tr.table__row.table__row--head
                      th.table__cell {{ 'base.ingredients' | translate }}
                      th.table__cell {{ 'base.stock' | translate }}
                      th.table__cell
                      th.table__cell
                      th.table__cell
                      th.table__cell

                  //- INGREDIENTS LIST
                  draggable(
                    tag="tbody"
                    handle=".cursor-move"
                    @end="updateIngredientsOrdering(ration)"
                    v-if="ration.ingredients.length"
                    v-model="ration.ingredients")
                    tr.table__row(
                      v-for="(ingredient, index) in ration.ingredients"
                      :key="index")

                      //- INGREDIENT NAME
                      td.table__cell
                        .flex.align-center
                          span {{ ingredient.name }}
                      td.table__cell
                        .ration-stock {{ ingredient.stock ? ingredient.stock.name : '-' }}

                      //- UK and non-UK layouts with container wrapper
                      td.table__cell.table__cell--thin
                        .ration-toggle-container
                          .two-cols(v-if="lang === 'uk'")
                            .ration-weight-item-wrap
                              span.ration-weight-item(v-if="!ration.is_dry || ingredient.name === 'H2O'")
                                input.ration-weight-item-input.input(
                                  type="number"
                                  step="0.01"
                                  :disabled="readOnly"
                                  :value="formatInputValue(ingredient.weight)"
                                  @input="onWeightInput(ingredient, $event)"
                                  @blur="onWeightChange(ingredient, $event); saveChanges(ration)")
                              span.ration-weight-item.disabled-field(v-else :data-tooltip="$t('base.enable_cm_mode')") {{ formatNumber(ingredient.weight) }}
                              span {{ 'base.kg' | translate }}
                            .ration-weight-item-wrap(v-if="ingredient.name !== 'H2O'")
                              span.ration-weight-item(v-if="ration.is_dry")
                                input.ration-weight-item-input.input(
                                  type="number"
                                  step="0.01"
                                  :disabled="readOnly || ingredient.dry_matter === 0"
                                  :value="formatInputValue(dryWeight(ingredient))"
                                  @input="onDryWeightInput(ingredient, $event)"
                                  @blur="onDryWeightChange(ingredient, $event); saveChanges(ration)")
                              span.ration-weight-item.disabled-field(v-else :data-tooltip="$t('base.enable_cp_mode')") {{ formatNumber(dryWeight(ingredient)) }}
                              span {{ 'base.kg' | translate }}
                            .ration-weight-item-wrap.h2o-placeholder(v-else)
                          .two-cols(v-else)
                            .ration-weight-item-wrap(v-if="ingredient.name !== 'H2O'")
                              span.ration-weight-item(v-if="ration.is_dry")
                                input.ration-weight-item-input.input(
                                  type="number"
                                  step="0.01"
                                  :disabled="readOnly || ingredient.dry_matter === 0"
                                  :value="formatInputValue(dryWeight(ingredient))"
                                  @input="onDryWeightInput(ingredient, $event)"
                                  @blur="onDryWeightChange(ingredient, $event); saveChanges(ration)")
                              span.ration-weight-item.disabled-field(v-else :data-tooltip="$t('base.enable_cp_mode')") {{ formatNumber(dryWeight(ingredient)) }}
                              span {{ 'base.kg' | translate }}
                            .ration-weight-item-wrap.h2o-placeholder(v-else)
                            .ration-weight-item-wrap
                              span.ration-weight-item(v-if="!ration.is_dry || ingredient.name === 'H2O'")
                                input.ration-weight-item-input.input(
                                  type="number"
                                  step="0.01"
                                  :disabled="readOnly"
                                  :value="formatInputValue(ingredient.weight)"
                                  @input="onWeightInput(ingredient, $event)"
                                  @blur="normalizeWeight(ingredient); saveChanges(ration)")
                              span.ration-weight-item.disabled-field(v-else :data-tooltip="$t('base.enable_cm_mode')") {{ formatNumber(ingredient.weight) }}
                              span {{ 'base.kg' | translate }}

                      //- PRICE AND ACTION
                      td.table__cell
                      td.table__cell
                        .nowrap {{ formatNumber(parseFloat((ingredient.weight * ingredient.price_per_kg).toFixed(2))) }} {{ 'base.currency' | translate }}
                      td.table__cell.table__cell--action
                  tr.table__row(v-else)
                    td.table__cell(colspan="7")
                      .table__empty {{ 'base.table_is_empty' | translate }}

    //- PAGINATION
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
</template>

<script>
import api from '@/api'
import Draggable from 'vuedraggable'
import paginationMixin from '@/mixins/pagination.mixin'
import UiPagination from '@/components/ui/ui-pagination/UiPagination'

export default {
  name: 'RationsTabel',

  mixins: [paginationMixin],

  components: {
    Draggable,
    UiPagination
  },

  computed: {
    allowView () {
      return this.hasPermission('ration', 'view')
    },

    readOnly () {
      return !this.hasPermission('ration', 'change')
    },

    lang () {
      return this.$store.getters['account/lang']
    }
  },

  mounted () {
    this.setupPagination(
      api.rations.list,
      { farm: this.$route.params.farm_id },
      `farm_${this.$route.params.farm_id}_rations`
    )
  },

  methods: {
    formatNumber (value) {
      if (value == null || value === '') return value
      const num = parseFloat(value)
      if (isNaN(num)) return value
      const fixed = num.toFixed(2)
      return String(fixed).replace('.', ',')
    },

    formatInputValue (value) {
      if (value == null || value === '') return ''
      const num = parseFloat(value)
      if (isNaN(num)) return ''
      return num.toFixed(2)
    },

    onWeightInput (ingredient, event) {
      const value = event.target.value
      if (value && value.includes('.')) {
        const parts = value.split('.')
        if (parts[1] && parts[1].length > 2) {
          event.target.value = parseFloat(parts[0] + '.' + parts[1].substring(0, 2)).toFixed(2)
        }
      }
    },
    onWeightChange (ingredient, event) {
      const value = parseFloat(event.target.value)

      if (isNaN(value) || value < 0) {
        ingredient.weight = 0
      } else {
        ingredient.weight = parseFloat(value.toFixed(2))
      }
    },

    onDryWeightInput (ingredient, event) {
      const value = event.target.value
      if (value && value.includes('.')) {
        const parts = value.split('.')
        if (parts[1] && parts[1].length > 2) {
          event.target.value = parseFloat(parts[0] + '.' + parts[1].substring(0, 2)).toFixed(2)
        }
      }
    },

    limitDecimals (ingredient, event) {
      const value = event.target.value
      if (value && value.includes('.')) {
        const parts = value.split('.')
        if (parts[1] && parts[1].length > 2) {
          ingredient.weight = parseFloat(parts[0] + '.' + parts[1].substring(0, 2))
          event.target.value = ingredient.weight.toFixed(2)
        }
      }
    },

    limitDecimalsDryWeight (event) {
      const value = event.target.value
      if (value && value.includes('.')) {
        const parts = value.split('.')
        if (parts[1] && parts[1].length > 2) {
          const limitedValue = parseFloat(parts[0] + '.' + parts[1].substring(0, 2))
          event.target.value = limitedValue.toFixed(2)
        }
      }
    },

    normalizeWeight (ingredient) {
      const weight = parseFloat(ingredient.weight)
      if (isNaN(weight) || weight < 0) {
        ingredient.weight = 0
      } else {
        ingredient.weight = parseFloat(weight.toFixed(2))
      }
    },

    saveChanges ({ id, ...payload }) {
      if (!this.readOnly) {
        api.rations.updateById(id, payload)
      }
    },

    updateIngredientsOrdering (ration) {
      ration.ingredients.forEach((ingredient, index) => {
        ingredient.ordering = index
      })
      this.saveChanges(ration)
    },

    removeIngredient (ration, index) {
      ration.ingredients.splice(index, 1)
      this.saveChanges(ration)
      this.$emit('close')
    },

    setIsDry (ration, value) {
      if (!this.readOnly && ration.is_dry !== value) {
        ration.is_dry = value
        this.saveChanges(ration)
      }
    },

    onDryWeightChange (ingredient, $event) {
      const value = parseFloat($event.target.value)

      if (isNaN(value) || value < 0 || ingredient.dry_matter === 0) {
        ingredient.weight = 0
        return
      }

      const dryMatter = ingredient.dry_matter > 100
        ? ingredient.dry_matter / 10000
        : ingredient.dry_matter / 100

      const weight = value / dryMatter

      // Округлення до 2 знаків після коми
      ingredient.weight = parseFloat(weight.toFixed(2))
    },

    dryWeight (ingredient) {
      const result = (ingredient.dry_matter > 100)
        ? Math.round(ingredient.weight * ingredient.dry_matter) / 10000
        : Math.round(ingredient.weight * ingredient.dry_matter) / 100
      return parseFloat(result.toFixed(2))
    },

    totalWeight (ration) {
      const sum = ration.ingredients
        .map(ingredient => ingredient.weight)
        .reduce((previousValue, currentValue) => previousValue + +currentValue, 0)
      return parseFloat(sum.toFixed(2))
    },

    totalDryWeight (ration) {
      const sum = ration.ingredients
        .map(ingredient => {
          const dryMatter = ingredient.dry_matter > 100 ? ingredient.dry_matter / 10000 : ingredient.dry_matter
          return ingredient.weight * dryMatter / 100
        })
        .reduce((previousValue, currentValue) => previousValue + currentValue, 0)
      return parseFloat(sum.toFixed(2))
    },

    totalPrice (ration) {
      const sum = ration.ingredients
        .map(ingredient => ingredient.weight * ingredient.price_per_kg)
        .reduce((previousValue, currentValue) => previousValue + currentValue, 0)
      return parseFloat(sum.toFixed(2))
    },

    rationHumidity (ration) {
      const weight = parseFloat(this.totalWeight(ration))
      const dry = parseFloat(this.totalDryWeight(ration))
      if (weight === 0) return 0
      const humidity = ((weight - dry) / weight) * 100
      return parseFloat(humidity.toFixed(2))
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';
.ration-selected-item-wrap {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  justify-content: center;
  &::after {
    display: none;
  }

  .ration-selected-item {
    padding: 0.8rem;
    border-radius: 0.5rem;
    font-weight: 900;
    min-width: 5.6rem;
    text-align: center;
  }


  &.selected .ration-selected-item {
    background-color: #DDF2E3;
  }

  &.fake {
    opacity: 0.3;
    pointer-events: none;

    .ration-selected-item {
      background-color: #EEE;
    }
  }
}

.ration-toggle-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.ration-toggle-container {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: #EEEEEE;
  border-radius: 1rem;
  padding: 0.4rem;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
}

// Remove background for ingredient rows
.table__row--merge-top {
  .ration-toggle-container {
    background: transparent;
    padding: 0;
  }
}

.ration-toggle-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 0.8rem;
  border-radius: 0.8rem;
  background: transparent;
  transition: all 0.2s ease;
  flex: 1 1 0;
  min-width: 0;
  max-width: 50%;
  justify-content: center;

  .ration-selected-item {
    font-weight: 900;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    flex-shrink: 1;
  }

  &.selected {
    background: #59CC56;
    color: white;
    
    .ration-selected-item {
      color: white;
    }
  }

  &:not(.selected) {
    background: transparent;
    color: #333;
  }

  &.cursor-pointer {
    cursor: pointer;
    
    &:not(.selected):hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
}

.ration-weight-item-wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1 0;
  min-width: 0;
  max-width: 50%;
  justify-content: center;
  position: relative;

  span:last-child {
    font-weight: 400;
    flex-shrink: 0;
    white-space: nowrap;
  }

  &.h2o-placeholder {
    visibility: hidden;
  }

  .disabled-field {
    cursor: help;
    
    &:hover::before {
      content: attr(data-tooltip);
      position: absolute;
      top: -100%;
      left: -100px;
      background-color: #ffe8f0;
      color: #ff6b9d;
      padding: 0.8rem 1.6rem;
      border-radius: 2rem;
      font-size: 1.3rem;
      font-weight: 500;
      white-space: nowrap;
      z-index: 1000;
    }
  }

  .ration-weight-item-input {
    background-color: #f8f8f8;
    padding: 0.8rem;
    border-radius: 0.5rem;
    font-weight: 500;
    width: 6.5rem;
    text-align: center;
    border: unset;

    &:disabled {
      background-color: gainsboro;
      cursor: not-allowed;
    }
  }
}

.ration-weight-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem;
  border-radius: 0.8rem;
  font-weight: 900;
  text-align: center;
  flex-shrink: 1;
  font-weight: 500;

  &:has(input) {
    padding: 0;
  }
  
  &.disabled-field {
    cursor: help;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
}

.two-cols {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
}

.table__cell {
  &:nth-child(1),
  &:nth-child(2),
  &:nth-child(4) {
    width: 18%;
    min-width: 160px;
    max-width: 18%;
  }

  &:nth-child(3) {
    width: 24%;
    min-width: 200px;
    max-width: 24%;
    text-align: center;
    box-sizing: border-box;
  }

  &:nth-child(4),
  &:nth-child(5),
  &:nth-child(6) {
    text-align: center;
  }

  &:nth-child(5),
  &:nth-child(6),
  &:nth-child(7) {
    width: auto;
  }

  &.min-width-cell {
    min-width: 100px;
  }
}

// Styles for nested ingredients table
.table__row--merge-top {
  .table {
    width: 100%;
    table-layout: fixed;

    .table__cell {
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(4) {
        width: 18% !important;
        min-width: 160px !important;
        max-width: 18% !important;
      }

      &:nth-child(3) {
        width: 24% !important;
        min-width: 200px !important;
        max-width: 24% !important;
        text-align: center !important;
        box-sizing: border-box !important;
      }

      &:nth-child(4),
      &:nth-child(5) {
        text-align: center !important;
      }

      &:nth-child(5),
      &:nth-child(6) {
        width: auto;
      }
    }
  }
}


.input {
  width: auto;
  max-width: 6.5rem;
  padding: .4rem;
  text-align: right;
  background-color: $color-gray-light-4;
  border-bottom: 1px solid $color-gray-light-2;
}

.selected {
  position: relative;
  cursor: default;

}

.ration-stock {
  max-width: 150px;
  word-wrap: break-word;
  word-break: break-word;

}

.header-toggle-labels {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 0.4rem;
  padding: 0.4rem;
  border-radius: 1rem;

  span {
    flex: 1 1 0;
    min-width: 0;
    max-width: 50%;
    text-align: center;
  }
}
.table__row--head .table__cell {
     padding: .8rem 2rem;
}
</style>